import React from "react";

const SubPicture = ({ img, fit = "cover" }) => {
  const visualClass =
    fit === "contain" ? "company-visual company-visual--contain" : "company-visual";

  return (
    <section className={visualClass}>
        <picture>
          <img src={img} alt="" />
        </picture>
      </section>
  );
};

export default SubPicture;
